import Home from './Home';
import Navbar from './Navbar';

function App() {
  return (
    <div>
      <Navbar />
      <Home />
    </div>
  );
}

export default App;
